import React from 'react';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import classnames from 'classnames';
import styles from './styles.module.scss';

const DocumentTitle = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const textLine1 = getTextLine1(context);
  const textLine2 = getTextLine2(context);

  return (
    <div
      className={classnames(styles.bold, styles.textCentered, styles.textUnderline, styles.documentTitleContainer)}
      ref={ref}
    >
      <div>{textLine1}</div>
      <div>{textLine2}</div>
    </div>
  );
});

const getTextLine1 = (context) => {
  const {
    data: {
      pdfData: {
        propertyTypeID,
        propertyTypeName,
        streetName,
        houseNumber,
        cityName,
        landLotNum,
        underConstruction,
        loanTypeID,
      },
    },
  } = context;

  const getPropertyTypeName = () => {
    switch (propertyTypeID) {
      case 1:
        return 'דירת מגורים';
      case 11:
        return Boolean(landLotNum) ? '' : propertyTypeName;
      default:
        return propertyTypeName;
    }
  };

  if (propertyTypeID === 11 && streetName && landLotNum) {
    return [
      'חוות דעת להערכת נכס מקרקעין -',
      getPropertyTypeName(),
      (loanTypeID === 6 || underConstruction) ? 'בבנייה' : '',
      Boolean(streetName) && 'מגרש ברחוב',
      Boolean(streetName) && streetName,
      Boolean(houseNumber) && `${houseNumber},`,
      propertyTypeID === 11
        ? Boolean(landLotNum) && `מגרש ${landLotNum},`
        : (!streetName || !houseNumber) && Boolean(landLotNum) && `מגרש ${landLotNum},`,
      `${cityName},`,
    ].filter(Boolean).join(' ');
  } else if (!streetName && !landLotNum) {
    return [
      'חוות דעת להערכת נכס מקרקעין -',
      getPropertyTypeName(),
      (loanTypeID === 6 || underConstruction) ? 'בבנייה' : '',
      Boolean(streetName) && 'מגרש ברחוב',
      Boolean(streetName) && `${streetName}`,
      Boolean(houseNumber) && `${houseNumber},`,
      propertyTypeID === 11
        ? Boolean(landLotNum) && `מגרש ${landLotNum},`
        : (!streetName || !houseNumber) && Boolean(landLotNum) && `מגרש ${landLotNum},`,
      `ב${cityName}` + ',',
    ].filter(Boolean).join(' ');
  } else {
    return [
      'חוות דעת להערכת נכס מקרקעין -',
      getPropertyTypeName(),
      (loanTypeID === 6 || underConstruction) ? 'בבנייה' : '',
      Boolean(streetName) && 'ברחוב',
      Boolean(streetName) && streetName,
      Boolean(houseNumber) && `${houseNumber},`,
      propertyTypeID === 11
        ? Boolean(landLotNum) && `מגרש ${landLotNum},`
        : (!streetName || !houseNumber) && Boolean(landLotNum) && `מגרש ${landLotNum},`,
      `${cityName},`,
    ].filter(Boolean).join(' ');
  }
};
const getTextLine2 = (context) => {
  const {
    data: {
      pdfData: {
        gush, helka, ttHelka,
      },
    },
  } = context;

  return [
    'גוש',
    `${gush}`,
    'חלקה',
    `${helka}`,
    ttHelka && 'תת חלקה',
    Boolean(ttHelka) ? `${ttHelka}` : '',
  ].filter(Boolean).join(' ');
};

export default DocumentTitle;
